/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVideosResponse
 */
export interface GetVideosResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetVideosResponse
     */
    videoIds: Array<string>;
}

/**
 * Check if a given object implements the GetVideosResponse interface.
 */
export function instanceOfGetVideosResponse(value: object): value is GetVideosResponse {
    if (!('videoIds' in value) || value['videoIds'] === undefined) return false;
    return true;
}

export function GetVideosResponseFromJSON(json: any): GetVideosResponse {
    return GetVideosResponseFromJSONTyped(json, false);
}

export function GetVideosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVideosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'videoIds': json['video_ids'],
    };
}

export function GetVideosResponseToJSON(json: any): GetVideosResponse {
    return GetVideosResponseToJSONTyped(json, false);
}

export function GetVideosResponseToJSONTyped(value?: GetVideosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'video_ids': value['videoIds'],
    };
}

